/** biome-ignore-all lint/correctness/useExhaustiveDependencies: it's ok */

import FetchService from "@core-ui/ApiServices/FetchService";
import AppBusy from "@core-ui/AppBusy";
import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import CatalogFetchTimersService from "@core-ui/ContextServices/CatalogFetchTimers";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import { useIsRepoOk } from "@ext/storage/logic/utils/useStorage";
import { useEffect, useRef } from "react";

const useFetchCatalog = () => {
	const catalogProps = useCatalogPropsStore((state) => state.data, "shallow");
	const apiUrlCreator = ApiUrlCreatorService.value;
	const isRepoOk = useIsRepoOk(catalogProps) && !!catalogProps?.name;
	const isRepoOkRef = useRef<boolean>(isRepoOk);
	const readOnly = PageDataContextService.value.conf.isReadOnly;

	const fetchCatalog = async () => {
		if (
			!catalogProps?.name ||
			!isRepoOkRef.current ||
			readOnly ||
			!CatalogFetchTimersService.canFetch(catalogProps.name)
		)
			return;

		const res = await AppBusy.run("sync", () => FetchService.fetch(apiUrlCreator.getStorageFetch()));
		if (!res) return;
		CatalogFetchTimersService.setTimer(catalogProps.name);
	};

	useEffect(() => {
		isRepoOkRef.current = isRepoOk;
	}, [isRepoOk]);

	useEffect(() => {
		const interval = setInterval(() => {
			if (document.hidden) return;
			void fetchCatalog();
		}, CatalogFetchTimersService.fetchIntervalDelay);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		void fetchCatalog();
	}, [catalogProps]);

	useEffect(() => {
		window.addEventListener("focus", fetchCatalog);
		return () => {
			window.removeEventListener("focus", fetchCatalog);
		};
	});
};

export default useFetchCatalog;
